module.exports = __webpack_public_path__ + "img/bilibili.8d804098.png";